import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  id: '',
  showModal: false,
  userDetailsModal: false,
  videoConfirmModal: false,
  videoModal: false,
  planModal: false,
  memberPlanModal: false,
  agentPlanModal: false,
  subscriptionModal: false,
  freeAccessModal: false,
  resendEmailModal: false,
  quickTransferModal: false,
  quickTransferConfirmModal: false,
  formDetails: {},
  files: [],
  selectedPage: 1
};

export const sharedSlice = createSlice({
  name: "sharedSlice",
  initialState: initialState,
  reducers: {
    setId: (state, { payload }) => {
      state.id = payload
    },
    setModalStatus: (state, { payload }) => {
      state.showModal = payload
    },
    setFormDetails: (state, { payload }) => {
      state.formDetails = payload
    },
    setVideoModal: (state, { payload }) => {
      state.videoModal = payload
    },
    setQuickTransferModal: (state, { payload }) => {
      state.quickTransferModal = payload
    },
    setUserModalStatus: (state, { payload }) => {
      state.userDetailsModal = payload
    },
    setVideoConfirmModalStatus: (state, { payload }) => {
      state.videoConfirmModal = payload
    },
    setQuickTransferConfirmModalStatus: (state, { payload }) => {
      state.quickTransferConfirmModal = payload
    },
    setPlanModalStatus: (state, { payload }) => {
      state.planModal = payload;
    },
    setAgentModalStatus: (state, { payload }) => {
      state.agentPlanModal = payload;
    },
    setSubscriptionModalStatus: (state, { payload }) => {
      state.subscriptionModal = payload;
    },
    setMemberPlanModalStatus: (state, { payload }) => {
      state.memberPlanModal = payload;
    },
    setFreeAccessModalStatus: (state, { payload }) => {
      state.freeAccessModal = payload;
    },
    setResendEmailModalStatus: (state, { payload }) => {
      console.log(">>>>     dispatch(setResendEmailModalStatus(true));")
      state.resendEmailModal = payload;
    }, 
    setFiles: (state, { payload }) => {
      state.files = payload.data
    },
    setPartnerProfileImages: (state, { payload }) => {
      state.formDetails.profilePicture = payload.data[0]?.url
    },
    setSelectedPage: (state, { payload }) => {
      state.selectedPage = payload
    },
  },
});

export const {
  setId,
  setModalStatus,
  setFormDetails,
  setVideoModal,
  setUserModalStatus,
  setFiles,
  setPartnerProfileImages,
  setVideoConfirmModalStatus,
  setSubscriptionModalStatus,
  setPlanModalStatus,
  setMemberPlanModalStatus,
  setFreeAccessModalStatus,
  setSelectedPage,
  setAgentModalStatus,
  setResendEmailModalStatus,
  setQuickTransferModal,
  setQuickTransferConfirmModalStatus
} = sharedSlice.actions;